<section class="container grid-container">
  <header class="grid-full-width">
    <mat-icon class="material-symbols-outlined" svgIcon="logo"></mat-icon>
    <h1 class="mat-headline-3">Galaxy</h1>
  </header>

  <div class="search-bar grid-full-width">
    <mat-form-field
      appearance="outline"
      class="dashboard-search-field"
      subscriptSizing="dynamic">
      <mat-icon matPrefix class="material-symbols-outlined">search</mat-icon>
      <input
        matInput
        type="search"
        placeholder="Search tools..."
        [value]="searchTerm()"
        (input)="searchTerm.set($any($event.target).value)"
        aria-label="Search tools" />
      @if (searchTerm()) {
        <button
          mat-icon-button
          matSuffix
          type="button"
          aria-label="Clear search"
          (click)="clearSearch()">
          <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
      }
    </mat-form-field>
  </div>

  <ng-template #tileCard let-tile="tile">
    <div class="dashboard-tile-wrapper">
      <button
        type="button"
        class="favorite-toggle"
        [class.is-favorite]="favorites.isFavorite(tile.route)"
        [attr.aria-pressed]="favorites.isFavorite(tile.route)"
        [attr.aria-label]="
          (favorites.isFavorite(tile.route) ? 'Remove ' : 'Add ') +
          tile.name +
          (favorites.isFavorite(tile.route) ? ' from' : ' to') +
          ' favorites'
        "
        (click)="toggleFavorite($event, tile.route)">
        <mat-icon class="material-symbols-outlined">{{
          favorites.isFavorite(tile.route) ? 'star' : 'star_outline'
        }}</mat-icon>
      </button>
      <a
        mat-stroked-button
        class="dashboard-tile"
        [routerLink]="tile.route"
        [need-permission]="tile.permission">
        <div class="dashboard-button-content">
          <span [class]="'tile-icon accent-' + tile.zone">
            <mat-icon
              [class]="tile.iconClass || null"
              class="material-symbols-outlined"
              >{{ tile.icon }}</mat-icon
            >
          </span>
          <span class="tile-label">{{ tile.name }}</span>
        </div>
      </a>
    </div>
  </ng-template>

  @if (filteredFavoriteTiles().length > 0) {
    <div class="section-header grid-full-width">
      <mat-icon class="material-symbols-outlined section-header-icon"
        >star</mat-icon
      >
      <h2>Favorites</h2>
      <span class="section-divider"></span>
      <span class="section-count">{{ filteredFavoriteTiles().length }}</span>
    </div>
    @for (tile of filteredFavoriteTiles(); track tile.route) {
      <ng-container *ngTemplateOutlet="tileCard; context: { tile: tile }" />
    }
  }

  @if (
    filteredCategories().length === 0 && filteredFavoriteTiles().length === 0
  ) {
    <div class="empty-state grid-full-width">
      <mat-icon class="material-symbols-outlined">search_off</mat-icon>
      <p>No tools match your search</p>
    </div>
  } @else {
    @for (category of filteredCategories(); track category.key) {
      <div class="section-header grid-full-width">
        <mat-icon class="material-symbols-outlined section-header-icon">{{
          category.icon
        }}</mat-icon>
        <h2>{{ category.title }}</h2>
        <span class="section-divider"></span>
        <span class="section-count">{{ category.itemCount }}</span>
      </div>

      @for (group of category.groups; track group.label ?? '$ungrouped') {
        @if (group.label) {
          <div class="subgroup-header grid-full-width">
            <mat-icon class="material-symbols-outlined subgroup-header-icon">{{
              group.icon
            }}</mat-icon>
            <span class="subgroup-label">{{ group.label }}</span>
          </div>
        }
        @for (tile of group.items; track tile.route) {
          <ng-container *ngTemplateOutlet="tileCard; context: { tile: tile }" />
        }
      }
    }
  }

  <footer class="grid-full-width">
    <div class="footer-wrapper">
      <a
        matTooltip="Documentation"
        mat-icon-button
        href="https://coa.dvtech.io/pages/viewpage.action?pageId=1000082374735">
        <mat-icon class="material-symbols-outlined">dictionary</mat-icon>
      </a>
      <mat-divider vertical></mat-divider>
      <glx-dark-mode-toggle></glx-dark-mode-toggle>
      <glx-user-menu></glx-user-menu>
    </div>
  </footer>
</section>
